const getMounth = (month: string) => {
    if (month === "01") return "Jan";
    if (month === "02") return "Feb";
    if (month === "03") return "Mar";
    if (month === "04") return "Apr";
    if (month === "05") return "May";
    if (month === "06") return "Jun";
    if (month === "07") return "Jul";
    if (month === "08") return "Aug";
    if (month === "09") return "Sep";
    if (month === "10") return "Oct";
    if (month === "11") return "Nov";
    if (month === "12") return "Dec";
    return "";
}

export default getMounth;

